/*
 * Single source of truth para estados de remesa y sus labels.
 * Backend: backend/models/remesas.py — RemesaEstado / TRANSICIONES_PERMITIDAS.
 */

export const REMESA_ESTADOS = ["borrador", "enviada", "cobrada", "cancelada"];

export const REMESA_ESTADO_LABEL = {
  borrador: "Borrador",
  enviada: "Enviada al banco",
  cobrada: "Cobrada",
  cancelada: "Cancelada",
  importada: "Importada",
};

// Colores tipo "chip" — paleta coherente con el resto de la app.
export const REMESA_ESTADO_STYLE = {
  borrador: "bg-amber-100 text-amber-800",
  importada: "bg-lime-100 text-lime-800",
  enviada: "bg-sky-100 text-sky-800",
  cobrada: "bg-emerald-100 text-emerald-800",
  cancelada: "bg-rose-100 text-rose-700 line-through decoration-rose-300",
};

export const REMESA_TRANSICIONES = {
  borrador: ["enviada", "cancelada"],
  enviada: ["cobrada", "cancelada"],
  cobrada: [],
  cancelada: [],
};

export const isEditable = (estado) => estado === "borrador";

export const MESES_ES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];
